import { Component, OnInit, Output, Input, EventEmitter, OnDestroy } from '@angular/core';
import { TimeCardService } from '../../../data/time-card.service';
import { AppStateQuery } from 'projects/desktop/src/app/data/app-state.query';
import { User } from 'projects/core/src/lib/login/data/user';
import { PayPeriod } from '../../../data/pay-period';
import { Subscription, timer } from 'rxjs';
import { takeUntilDestroyed, trackEntityById } from 'projects/core/src/public-api';

class StartEndPeriod {
    start: string;
    end: string;
}

@Component({
    selector: 'app-pay-period',
    templateUrl: './pay-period.component.html',
    styleUrls: ['./pay-period.component.scss']
})
export class PayPeriodComponent implements OnInit, OnDestroy {
    currentUser: User;
    payPeriods: PayPeriod[];

    activeIndex = 0;

    @Input()
    halfPeriod = false;

    @Output()
    updatePayPeriod = new EventEmitter<StartEndPeriod>();

    trackEntityById = trackEntityById;

    timerSub: Subscription

    constructor(
        private timeCardsService: TimeCardService,
        private appStateQuery: AppStateQuery
    ) { }

    ngOnInit() {
        this.appStateQuery.currentUser$.subscribe(currentUser => {
            this.currentUser = currentUser
            console.log('halfPeriod', this.halfPeriod)
            this.timeCardsService.getLastPayPeriodsForUser(this.currentUser.id, this.halfPeriod).subscribe(periods => {
                this.payPeriods = periods
            })
        });

    }

    getDuration(time: number) {
        let durationString = '';

        const hours = Math.trunc(time / 60)
        const minutes = Math.trunc(time - hours * 60)
        durationString = hours + 'h ' + minutes + 'm'
        return durationString


    }

    onTabChanged(e) {
        this.activeIndex = e.index
    }

    ngOnDestroy() {
        // this.timerSub.unsubscribe();
    }

}
